import React from "react";

interface IProps {
  children:React.ReactNode,
  style?: React.CSSProperties,
}

const CpntForm: React.FC<IProps> = ({ children, style }) => {
  return (
    <div style={style} className="card form-card">
      {React.Children.map(children, (child, i) => {
        if (child) {
          return <div key={"CpntForm" + i}>{child}</div>;
        }
      })}
    </div>
  );
};

export default CpntForm;
